/**
 * Simple local storage helpers for JSON objects with namespace.
 */

const NAMESPACE = 'atscv:local';

function ns(key: string) {
  return `${NAMESPACE}:${key}`;
}

export function save<T>(key: string, value: T): void {
  localStorage.setItem(ns(key), JSON.stringify(value));
}

export function load<T>(key: string, fallback: T): T {
  const raw = localStorage.getItem(ns(key));
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function remove(key: string): void {
  localStorage.removeItem(ns(key));
}












